// extracted by mini-css-extract-plugin
export var menuIcon = "_qe-0";
export var menuIconInline = "_qe-1";